<div class="bmc-user-jobs-list">
  <h4 class="bz-font-weight--semibold">{{'USERJOBS.JOB_LIST' | translate}}</h4>
  <div class="bmc-user-jobs-list__search-box bz-border-radius--m">
    <bzg-input [placeholder]="('USERJOBS.SEARCH' | translate)" class="bmc-user-jobs-list__search-box__text"
      name="search-box" [(ngModel)]="searchValue" actionIcnPosition="right">
      <bzg-icon nameIcon="icon-search"></bzg-icon>
    </bzg-input>
  </div>
  <ul class="bmc-user-jobs-list__items">
    <li class="bmc-user-jobs-list__item bz-shadow--xs bz-border-radius--m"
      [ngClass]="{'bz-color-bg--theme-100': userJob === selectedJob}"
      *ngFor="let userJob of userJobs | userJobsList:searchValue" (click)="setCurrentJob(userJob)">
      <h5 class="bz-font-weight--semibold">{{userJob.name}}</h5>
      <div *ngIf="userJob.enabled">
        <h5 class="bmc-user-jobs-list__item__middle-text bz-font-size--body-small">
          {{'USERJOBS.NEXT_RUN_TIME' | translate}}: {{userJob.nextRuntime | date:'MM/dd/yyyy h:mm a'}}
          <svg class="bz-icn bz-icon-svg--16">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </h5>
        <h5
          class="bmc-user-jobs-list__item__bottom-text bz-font-style--italic bz-font-size--body-small bz-color--theme-400">
          {{ 'USERJOBS.ENABLED' | translate}}
        </h5>
      </div>
      <div *ngIf="!userJob.enabled">
        <h5 class="bmc-user-jobs-list__item__middle-text bz-font-size--body-small">
          {{'USERJOBS.LAST_EXECUTED_TIME' | translate}}: 
          <span class="bmc-user-jobs-list__item__middle-text-space" *ngIf="userJob.lastProcessingTime"> {{userJob.lastProcessingTime | date:'MM/dd/yyyy h:mm a'}}</span>  
          <span class="bmc-user-jobs-list__item__middle-text-space" *ngIf="!userJob.lastProcessingTime"> {{'USERJOBS.NOT_EXECUTED' | translate}}</span>          
          <svg class="bz-icn bz-icon-svg--16">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </h5>
        <h5
          class="bmc-user-jobs-list__item__bottom-text bz-font-style--italic bz-font-size--body-small bz-color--neutral-400">
          {{ 'USERJOBS.DISABLED' | translate}}
        </h5>
      </div>
    </li>
  </ul>
</div>